import React, { Fragment } from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles(() => ({
  resize: {
    padding: 14,
  },
  label: {
    marginTop: 9,
    fontSize: 16,
    color: "#1558a2",
    fontWeight: 700,
    marginRight: 10,
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "center",
  },
}));

const ChangeQAStatus = (props) => {
  const { handleClose, open, state, onHandleChange, onSaveClick } = props;
  const classes = useStyles();

  // eslint-disable-next-line no-unused-vars
  const [personName, setPersonName] = React.useState();

  return (
    <Fragment>
      <ControlledDialog
        hideClose
        open={open}
        disableBackdropClick
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <Tooltip title="Back">
              <IconButton onClick={() => handleClose()}>
                <ArrowBackIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >{`${state.selectedQAItem.label}`}</span>
          </Fragment>
        }
        content={
          <Fragment>
            <div>
              <div className={classes.label}>Status NO</div>
            </div>
            <br></br>
            <br></br>
            <br></br>

            <FormControl
              style={{ width: "100%" }}
              variant="outlined"
              className={classes.formControl}
            >
              <InputLabel htmlFor="outlined-age-native-simple">
                Remarks
              </InputLabel>
              <Select
                native
                value={state.qaRemarks}
                onChange={onHandleChange}
                label="Remarks"
                inputProps={{
                  name: "qaRemarks",
                  id: "outlined-age-native-simple",
                }}
              >
                {state.remarksNoData.map((remarks) => (
                  <option key={remarks.id} value={remarks.id}>
                    {remarks.label}
                  </option>
                ))}
              </Select>
            </FormControl>
            <div className={classes.actions}>
              <Button
                onClick={() => onSaveClick()}
                disabled={state.isLoading}
                style={{ width: 100 }}
                variant="contained"
                color="primary"
              >
                {state.isLoading ? <CircularProgress size={30} /> : "Save"}
              </Button>
              <Button
                style={{ marginLeft: 20 }}
                onClick={() => handleClose()}
                variant="contained"
              >
                Cancel
              </Button>
            </div>
          </Fragment>
        }
      />
    </Fragment>
  );
};

ChangeQAStatus.propTypes = {
  handleClose: PropTypes.func,
  onHandleChange: PropTypes.func,
  onCheckClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  open: PropTypes.bool,
  state: PropTypes.object,
};

ChangeQAStatus.defaultProps = {
  handleClose: (fn) => fn,
  onHandleChange: (fn) => fn,
  onSaveClick: (fn) => fn,
  onCheckClick: (fn) => fn,
  open: false,
  state: {},
};

export default ChangeQAStatus;
